export default __webpack_public_path__ + "static/media/O-157.834db43d.png";